module.exports = __webpack_public_path__ + "static/media/dzip-logo-white.d21ba81a.svg";